import { useSelector } from '../../stores/dashboard.store'
import { fetchAllFromGallery } from '../../api-client/data'
import { useMediaQuery } from '@mui/material'
import { IconButton } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import useFetch from '../../hooks/useFetch'
import GalleryItem from '../../components/gallery/gallery-item'
import styles from './styles.module.css'

import MobileGallery from './gallery.mobile'
import { DashboardBody, DashboardHeader } from '../dashboard-container'
import NoContent from '../forms/no-content'

export default function DashboardGallery() {
    const blueprintId = useSelector(x => x?.activeProject?.id)
    const galleryData = useFetch(() => fetchAllFromGallery(blueprintId), [])
    const isMobile = useMediaQuery('(max-width: 900px)')

    if (isMobile) return <MobileGallery galleryData={galleryData} />

    return (
        <div className={styles.dashboardContent}>
            <DashboardHeader title="Gallery">
                <IconButton style={{ color: 'var(--text-primary)' }} onClick={galleryData.refresh}>
                    <RefreshIcon style={{ fontSize: 20 }} />
                </IconButton>
            </DashboardHeader>
            <DashboardBody loading={galleryData?.loading}>
                <div style={{ marginBottom: 45, display: 'flex', gap: 25, flexDirection: 'row', flexWrap: "wrap" }}>
                    {
                        galleryData?.data?.length > 0 ? galleryData?.data?.map(x => (
                            <GalleryItem {...x} refreshGallery={galleryData.refresh} />
                        )) : <NoContent />
                    }
                </div>
            </DashboardBody>

        </div>
    )
}
